export const permissions = {
    permissions: ['GEN_AI_LANDING_PAGES_VIEW'],
};
